import React, { createContext } from "react";

export const VersionContext = createContext(null);
